import { styled } from "stitches";

export const CenteredContainer = styled("div", {
    width: "100%",
	maxWidth: "1280px",
	marginLeft: "auto",
	marginRight: "auto",
	paddingLeft: "$2",
	paddingRight: "$2",
});
